// Calculo de parcelas espelhando o backend (routers/sales.py):
// cada parcela = arredondamento(financiado / n) em 2 casas; a ULTIMA parcela
// absorve a diferenca de arredondamento para que a soma seja EXATAMENTE o valor financiado.
// Vencimentos: primeira na data base informada (ou +30 dias), depois +1 mes mantendo o dia
// (ex: dia 10 continua dia 10 todo mes; clampa para o ultimo dia em meses mais curtos).

function round2(x) {
  return Math.round((Number(x) || 0) * 100) / 100;
}

export function addMonthsKeepDay(base, months) {
  const d = new Date(base);
  const day = d.getDate();
  const target = new Date(d.getFullYear(), d.getMonth() + months, 1);
  const lastDay = new Date(target.getFullYear(), target.getMonth() + 1, 0).getDate();
  target.setDate(Math.min(day, lastDay));
  return target;
}

// Proxima ocorrencia de um dia fixo do mes (1-28). Se o dia ja passou neste mes,
// usa o proximo mes. Retorna string ISO (yyyy-mm-dd).
export function nextDueDateForDay(day) {
  const today = new Date();
  const d = Math.min(Math.max(parseInt(day, 10) || 1, 1), 28);
  let target = new Date(today.getFullYear(), today.getMonth(), d);
  if (d <= today.getDate()) {
    target = new Date(today.getFullYear(), today.getMonth() + 1, d);
  }
  return toISODate(target);
}

export function toISODate(date) {
  const d = new Date(date);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function defaultFirstDue() {
  return toISODate(new Date(Date.now() + 30 * 86400000));
}

export function computeInstallments(financed, count, firstDueISO) {
  const n = Math.max(1, parseInt(count, 10) || 1);
  const fin = round2(financed);
  if (fin <= 0) return [];

  const per = round2(fin / n);
  // Interpreta a data ISO como data local (evita shift de fuso)
  const base = firstDueISO ? new Date(`${firstDueISO}T00:00:00`) : new Date(Date.now() + 30 * 86400000);

  const rows = [];
  for (let i = 0; i < n; i++) {
    const due = addMonthsKeepDay(base, i);
    const amount = i < n - 1 ? per : round2(fin - per * (n - 1));
    rows.push({ number: i + 1, amount, dueDate: due });
  }
  return rows;
}

export function installmentsSum(rows) {
  return round2(rows.reduce((a, r) => a + r.amount, 0));
}
